import {Controller} from "@hotwired/stimulus"
export default class extends Controller {

    connect() {
        this.updateTheme()
    }

    setTheme(event: any) {
        localStorage.setItem('theme', event.params.theme)
        this.updateTheme()
        const details = event.target.closest("details");
        if (details) {
            details.removeAttribute("open");
        }
    }

    updateTheme() {
        document.documentElement.setAttribute('data-theme', localStorage.getItem('theme') || 'winter')
    }

}
